import React, { useEffect } from "react";
import { Button } from "@launchmetrics/lm-ui";

const Error401 = () => {
    const redirectUrl = localStorage.getItem("redirectUrl");

    useEffect(() => {
        if (redirectUrl) {
            const timer = setTimeout(() => {
                localStorage.removeItem("redirectUrl");
                window.location.href = redirectUrl;
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [redirectUrl]);

    const handleManualRedirect = () => {
        if (redirectUrl) {
            localStorage.removeItem("redirectUrl");
            window.location.href = redirectUrl;
        }
    };

    return (
        <div className="text-center">
            <h1 className="display-1 font-weight-bold">401</h1>
            <p className="h1">Unauthenticated</p>
            <p className="h3 font-weight-normal mt-3 mb-4">
                Your session has expired and you have been logged out.
                Please log in again. You will be redirected in 5 seconds.
            </p>
            {redirectUrl && (
                <Button onClick={handleManualRedirect} className="btn btn-primary">
                    Login  Now
                </Button>
            )}
        </div>
    );
};

export default Error401;
